import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  BizMenuResource,
  DepositListSearchConditionResource,
  GenericFlagMgtResource,
  ItemServiceSettingResource, MasterAutoInsertResource,
  MasterPrecheckResource,
  RepairSlipQuantityManageResource,
  SfSlipCountMgtResource,
  SfSlipResource,
  AirisInquiryResultDataResource,
  CsSlipCountMgtResource,
  PayListSearchConditionResource,
  GlassSlipInfoResource,
  DiagnosisResultInfoResource,
  ActualSearchSettingResource,
  EstimatesRequestResource,
  YahooOrderInfoResource,
  YahooApplicationIdSettingResource,
  YahooStockQuantityInfoResource,
  PurchaseSlipInfoSearchResource,
  PayoutMoveSlipInfoSearchResource,
  OnlineCompanySettingResource,
  CollectExpectRecalculateResource,
  ContractCompanyInfoResource,
  BlPayApplyInfoResource,
  BiToolTaskResource,
  NotificationMessageResource,
  ReserveSearchResource,
  OrderPartsCartResource,
  PartsOrderFavoriteDisplayResource,
  OrderMemoAutoPrintErrorInfoResource,
  ChatListDisplayInfoResource,
  CommonGenericFlagMgtResource,
  BillSettingResource,
  ReportLayoutSettingResource,
  OpeHistoryResource,
  PrintPositionSettingResource,
  GenericPrintInstructionResource,
  ExportPatternInfoResource,
  PmOpeHistoryResource,
  UserInformationResource,
  SharedVehicleStockTransInfoResource,
  SharedVehicleStockInfoResource,
} from '@blcloud/bl-ng-resource';

import { BizMenuPageComponent } from './biz-menu-page.component';
import {
  AddOptionModalModule,
  BlNgShareCommonModule,
  ScheduleTimeTableModule,
  PrintPreviewModalModule,
  PmOpeHistoryResourceInsertService,
  CustomerInfoResourceService,
  SupplierInfoResourceService,
  IsshinTasukeMenuSettingModalModule
} from '@blcloud/bl-ng-share-module';
import { BizMenuPageRoutingModule } from './biz-menu-page-routing.module';
import { TooltipModule } from 'ngx-bootstrap';
import { ActualCurrencyPipe } from '../../shared/pipe/actual-currency.pipe';
import { OrdermemoResource } from './biz-menu-page.define';
import { ExportRequestConfirmComponent } from '../../feature/export-modal/export-request-confirm/export-request-confirm.component';
import { ExportPatternModalComponent } from '../../feature/export-modal/export-pattern-modal/export-pattern-modal.component';
import {
  CreditExportConditionModalComponent
} from '../../feature/export-modal/credit-export-condition-modal/credit-export-condition-modal.component';
import {
  DebtExportConditionModalComponent
} from '../../feature/export-modal/debt-export-condition-modal/debt-export-condition-modal.component';
import { BizMenuPageService } from './biz-menu-page.service';
import { IsshinTasukeMenuService } from './isshin-tasuke-menu/isshin-tasuke-menu.service';
import { IsshinTasukeMenuViewComponent } from './isshin-tasuke-menu/view/isshin-tasuke-menu-view.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BlNgCommonModule,
    BlNgShareCommonModule,
    BlNgUiComponentModule,
    ScheduleTimeTableModule,
    TooltipModule,
    AddOptionModalModule,
    BizMenuPageRoutingModule,
    PrintPreviewModalModule,
    IsshinTasukeMenuSettingModalModule.forRoot(),
  ],
  declarations: [
    BizMenuPageComponent,
    IsshinTasukeMenuViewComponent,
    ActualCurrencyPipe,
    ExportRequestConfirmComponent,
    ExportPatternModalComponent,
    CreditExportConditionModalComponent,
    DebtExportConditionModalComponent,
  ],
  exports: [
    BizMenuPageComponent,
  ],
  providers: [
    BizMenuPageService,
    SfSlipCountMgtResource,
    ItemServiceSettingResource,
    GenericFlagMgtResource,
    RepairSlipQuantityManageResource,
    BizMenuResource,
    MasterPrecheckResource,
    MasterAutoInsertResource,
    DepositListSearchConditionResource,
    SfSlipResource,
    AirisInquiryResultDataResource,
    CsSlipCountMgtResource,
    PayListSearchConditionResource,
    GlassSlipInfoResource,
    DiagnosisResultInfoResource,
    ActualSearchSettingResource,
    EstimatesRequestResource,
    YahooOrderInfoResource,
    YahooApplicationIdSettingResource,
    YahooStockQuantityInfoResource,
    PurchaseSlipInfoSearchResource,
    PayoutMoveSlipInfoSearchResource,
    OnlineCompanySettingResource,
    CollectExpectRecalculateResource,
    ContractCompanyInfoResource,
    BlPayApplyInfoResource,
    BiToolTaskResource,
    NotificationMessageResource,
    ReserveSearchResource,
    OrdermemoResource,
    OrderPartsCartResource,
    PartsOrderFavoriteDisplayResource,
    OrderMemoAutoPrintErrorInfoResource,
    ChatListDisplayInfoResource,
    CommonGenericFlagMgtResource,
    BillSettingResource,
    ReportLayoutSettingResource,
    ExportPatternInfoResource,
    GenericPrintInstructionResource,
    PrintPositionSettingResource,
    OpeHistoryResource,
    PmOpeHistoryResourceInsertService,
    PmOpeHistoryResource,
    CustomerInfoResourceService,
    SupplierInfoResourceService,
    IsshinTasukeMenuService,
    UserInformationResource,
    SharedVehicleStockTransInfoResource,
    SharedVehicleStockInfoResource,
  ],
  entryComponents: [
    ExportRequestConfirmComponent,
    ExportPatternModalComponent,
    CreditExportConditionModalComponent,
    DebtExportConditionModalComponent,
  ]
})
export class BizMenuPageModule {
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/biz-menu-page.module.ts